<template>
  <a-modal
      title="电话请假设置"
      :visible="visible"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      width="80vw" centered
  >
    <template slot="footer">
      <a-button type="primary" @click="handleCancel">关闭</a-button>
    </template>

    <a-card class="mb-3">
      <a-form-model :model="queryParam" class="exi_form v2"
                    :label-col="{ flex: '0 0 auto' }"
                    :wrapper-col="{ span: 24 }">
        <a-form-model-item label="身份证">
          <a-input placeholder="身份证" v-model="queryParam.idCard" style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="姓名">
          <a-input placeholder="请输入完整姓名" v-model="queryParam.expertName"
                   style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号" style="width: 250px">
          <a-input v-model="queryParam.mobilePhone"
                   placeholder="手机号"/>
        </a-form-model-item>
        <a-button type="primary" icon="search" @click="getExpertLeaveList">查询</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <table class="cq_table">
        <tr>
          <th>专家名称</th>
          <th>手机号</th>
          <th>身份证</th>
          <th>专家反馈</th>
          <th>操作</th>
        </tr>
        <tr v-for="item in expertLeaveList">
          <td>{{ item.expertName }}</td>
          <td>{{ item.mobilePhone }}</td>
          <td>{{ item.idCard }}</td>
          <td>{{ item.expertFlagText }}</td>
          <td>
            <a-button type="primary" size="small" @click="onLeave(item)">请假</a-button>
          </td>
        </tr>
      </table>
    </a-card>
  </a-modal>

</template>

<script>
import { GetExpertLeaveList } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import { ExtractExpertFlagEnum, TipsMessage } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

export default {
  name: 'PhoneLeaveSetModal',
  components: {},
  mounted () {
  },
  watch: {
    visible (val) {
      if (val) {
          this.clearMethod()
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyId: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      queryParam: {
        idCard: undefined,
        expertName: undefined,
        mobilePhone: undefined,
      },
      defaultParam: {
        applyId: this.applyId
      },
      confirmLoading: false,
      expertLeaveList: []
    }
  },
  created () {
  },
  methods: {
    onLeave (item) {
      let data = { ...item }
      data.expertFlag = ExtractExpertFlagEnum.LEAVE[0]
      this.$emit('onOpenExpertFlag', data, true)
    },
    async getExpertLeaveList (isShowWarn) {
      let data = {
        ...this.defaultParam, ...this.queryParam
      }
      let res = await GetExpertLeaveList(data)
      this.expertLeaveList = res.result || []
      if ((!res.result || res.result.length === 0 )&& isShowWarn){
        TipsMessage(this, '$warning', '未查询到本项目的专家，请查证后再操作！')
      }
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //清空的方法
    clearMethod (isShowWarn) {
      this.queryParam = {}
      this.getExpertLeaveList(isShowWarn)
    },

  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

.close-span:hover {
  cursor: pointer;
}
</style>
